export default __webpack_public_path__ + "static/4-2ec485f7a26c1bab9dd03c210c493ccc.jpg";